<div class="d-flex align-items-center justify-content-center">
    <div class="l-uploader-input">
        <label class="attach-file-btn cursor-pointer" for="upload-document">{{'contractModifications.wizard.attachFileBtn' | translate}}</label>
        <input 
            type="file" 
            class="l-input-file" 
            [accept]="acceptExtensions"
            (change)="uploadFilesHandler(clientDataRequest.documentsAttached, $event)" 
            id="upload-document"
        />
    </div>
    <span class="px-3">
        {{'common.or' | translate }}
    </span>           
    <button type="button" class="btn primary-btn image-capture-btn" (click)="openImageCaptureModal()">
        <i class="app-icon icon icon-image-take icon-xl me-2"></i>
        <span>{{ 'common.scan' | translate }}</span>
    </button>
</div>

<div class="l-upload-section-content gap-3 mt-3">
    <div *ngFor="let file of clientDataRequest?.documentsAttached" 
        class="l-file-container px-2 d-flex align-items-center gap-2 mw-100">
        <div class="d-flex flex-column flex-grow-1 overflow-hidden">
            <span class="l-file-name text-ellipsis">{{file.documentName}}</span>
            <span class="l-file-size text-ellipsis">{{file.convertedDocumentSize}}</span>
        </div>
        <button type="button" class="btn delete-btn custom-delete-btn" 
            (click)="deleteFileHandler(clientDataRequest.documentsAttached, file)">
            <i class="app-icon icon icon-delete icon-md2"></i>
        </button>
    </div>
    
</div>